import { Injectable } from '@angular/core';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import { NbRoleProvider } from '@nebular/security';
import { Observable } from 'rxjs-compat';
import { map } from 'rxjs/operators';
import { CurrentMemberProvider } from './current-member-provider.service';

@Injectable()
export class RoleProvider implements NbRoleProvider {

  constructor(
    private nbAuthService: NbAuthService,
    private currentMemberProvider: CurrentMemberProvider,
  ) {
  }

  getRole(): Observable<string> {
    return this.nbAuthService.onTokenChange()
      .pipe(
        map((token: NbAuthJWTToken) => {
          if (false === token.isValid()) {
            return 'guest';
          }

          return this.currentMemberProvider.isExternal() ? 'externalMember' : 'internalMember';
        }),
      );
  }
}
